import React from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

function formatMerchantDatePickerValue(mode, selected, startDate, endDate, placeholder) {
  if (mode === "range" || mode === "month-range") {
    const rangeFormat = mode === "month-range" ? "MMM yyyy" : "dd MMM yyyy";

    if (startDate && endDate) {
      return (
        format(startDate, rangeFormat) + " - " + format(endDate, rangeFormat)
      );
    }

    if (startDate) {
      return format(startDate, rangeFormat) + " -";
    }

    return placeholder;
  }

  if (!selected) {
    return placeholder;
  }

  return format(selected, mode === "month" ? "MMM yyyy" : "dd MMM yyyy");
}

const MerchantDatePickerInput = React.forwardRef(function MerchantDatePickerInput(props, ref) {
  const {
    disabled,
    onClick,
    valueLabel,
  } = props;

  return (
    <button
      className="merchant-date-picker-trigger"
      type="button"
      onClick={onClick}
      disabled={disabled}
      ref={ref}
    >
      <span className="merchant-date-picker-trigger-label">{valueLabel}</span>
      <span className="merchant-date-picker-trigger-icon" aria-hidden="true">
        ▾
      </span>
    </button>
  );
});

export default function MerchantDatePickerField({
  disabled,
  endDate,
  maxDate,
  minDate,
  mode,
  onChange,
  placeholder,
  selected,
  startDate,
}) {
  const pickerMode = mode || "date";
  const isRangePicker = pickerMode === "range" || pickerMode === "month-range";
  const isMonthPicker = pickerMode === "month" || pickerMode === "month-range";
  const isMonthRangePicker = pickerMode === "month-range";
  const valueLabel = formatMerchantDatePickerValue(
    pickerMode,
    selected,
    startDate,
    endDate,
    placeholder || "Select date",
  );
  const calendarClassName = isMonthRangePicker
    ? "merchant-date-picker-calendar merchant-date-picker-calendar-month-range"
    : "merchant-date-picker-calendar";
  const popperClassName = isMonthRangePicker
    ? "merchant-date-picker-popper merchant-date-picker-popper-month-range"
    : "merchant-date-picker-popper";

  return (
    <div className="merchant-date-picker">
      <DatePicker
        calendarClassName={calendarClassName}
        customInput={
          <MerchantDatePickerInput
            disabled={disabled}
            valueLabel={valueLabel}
          />
        }
        dateFormat={isMonthPicker ? "MMM yyyy" : "dd MMM yyyy"}
        disabled={disabled}
        endDate={endDate}
        maxDate={maxDate}
        minDate={minDate}
        monthsShown={isMonthRangePicker ? 1 : isRangePicker ? 2 : 1}
        onChange={onChange}
        popperClassName={popperClassName}
        selected={selected}
        shouldCloseOnSelect={!isRangePicker}
        showFourColumnMonthYearPicker={isMonthRangePicker}
        showMonthYearPicker={isMonthPicker}
        showPopperArrow={false}
        startDate={startDate}
        selectsRange={isRangePicker}
      />
    </div>
  );
}
